const runGetIterableEmailIdInputInitValue = require("./runGetIterableEmailIdInputInitValue");
const runAppendIterableEmailIdInputToAllForms = require("./runAppendIterableEmailIdInputToAllForms");
const runSetIterableEmailIdToTheSessionStorage = require("./runSetIterableEmailIdToTheSessionStorage");

module.exports = function thenAppendIterableEmailIdInputToAllForms() {
  const emailId = runGetIterableEmailIdInputInitValue();
  runAppendIterableEmailIdInputToAllForms(emailId);
  runSetIterableEmailIdToTheSessionStorage(emailId);
};
